import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import { saveAccountingJournal } from "../../../../../services/finance/accountingJournal";
import JournalEntriesHead from "./journalEntriesHead";
import JournalEntriesItem from "./journalEntriesItem";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import { getGlAccount } from "../../../../../services/setup/finance/financeSetupService";
const journalEntriesSchema = yup.object().shape({
  ID: yup.number(),
  currencyCode: yup.string().required("Currency is required"),
  totalAmount: yup.number().min(1, "Total Amount cannot be zero"),
  accountingItems: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      accountID: yup.number(),
      dbInd: yup.string().required("DC Ind is required"),
      accountName: yup.string().required("GL Account is required"),
      note: yup.string().required("Note is required"),
    })
  ),
});
function JournalEntriesForm({ history }) {
  const { companyProfile } = useGlobalData();
  const [accounting, setAccounting] = useState({
    ID: 0,
    divGlAccountID: 0,
    divGlAccountName: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    totalAmount: 0,
    documentDate: DateTime.now().startOf("day"),
    exchangeRate: 1,
    totalDebit: 0,
    totalCredit: 0,
    note: "",
    dividend: false,
    autoItem: false,
    accountingItems: [],
  });
  useEffect(() => {
    getDividendGlAccount();
  }, []);

  const getDividendGlAccount = async () => {
    const response = await getGlAccount(0, 27);
    const { data } = response.data;
    const accountingTmp = { ...accounting };
    accountingTmp.divGlAccountID = data.glAccount.ID;
    accountingTmp.divGlAccountName = data.glAccount.accountName;
    setAccounting(accountingTmp);
  };
  return (
    <React.Fragment>
      <PageSubHeader
        title="Journal Entry Form"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/journal-entries",
            title: "Accounting Journal Entries",
            active: true,
          },
          {
            page: "/finance/journal-entry-form",
            title: "Journal Entry Form",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/journal-entries");
            },
          },
        ]}
      />
      <AppForm
        initialValues={accounting}
        validationSchema={journalEntriesSchema}
        headSubmitButton
        onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
          values.totalAmount = parseFloat(values.totalAmount);
          values.exchangeRate = parseFloat(values.exchangeRate);
          for (const item of values.accountingItems) {
            if (item.damount > 0) {
              item.amount = parseFloat(item.damount);
            } else if (item.camount > 0) {
              item.amount = parseFloat(item.camount);
            }
          }
          if (values.totalCredit === values.totalDebit) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            })
              .fire({
                title:
                  "Are you sure want to save this Accounting Journal Document ?",
                text: "Please note that you are responsible for this action",
                icon: "question",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
                cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                reverseButtons: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  saveAccountingJournal(values).then((response) => {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Saved",
                      html: response.data.message,
                      icon: "success",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                    history.push("/finance/journal-entries");
                  });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Cancelled",
                    text: "No change has been made",
                    icon: "info",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                }
              });
          } else {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Failed",
              text: "Debit and Credit are not balanced",
              icon: "error",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
          }
        }}
      >
        <ContentLayout>
          <JournalEntriesHead />
          <JournalEntriesItem />
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );
}

export default JournalEntriesForm;
